import { Page } from '@/core/architecture'

import { ConsoleUserOrdersTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleUserOrders Page
 * Implemented as a practical sample.
 */
export const ConsoleUserOrders: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleUserOrdersTemplate state={state} {...actions} />
}
